function createLazyRemoteReducer(importFn) {
  let realReducer = null;

  const reducer = (state = {}, action) => {
    if (realReducer) return realReducer(state, action);
    return state;
  };

  importFn()
    .then((mod) => {
      realReducer = mod.default;
    })
    .catch((err) =>
      console.warn('[Federation] Remote reducer unavailable:', err.message),
    );

  return reducer;
}

export const RiskManagementReducer = createLazyRemoteReducer(() => import('remoteReactApp/RiskManagementReducer'));
export const RiskMitigationReducer = createLazyRemoteReducer(() => import('remoteReactApp/RiskMitigationReducer'));
export const RiskMitigationHistoryReducer = createLazyRemoteReducer(() => import('remoteReactApp/RiskMitigationHistoryReducer'));
export const SendMailReducer = createLazyRemoteReducer(() => import('remoteReactApp/SendMailReducer'));
export const RiskMitigationRowGroupingReducer = createLazyRemoteReducer(() => import('remoteReactApp/RiskMitigationRowGroupingReducer'));
export const SuppliersReducer = createLazyRemoteReducer(() => import('remoteReactApp/SuppliersReducer'));
export const FinanceReducer = createLazyRemoteReducer(() => import('remoteReactApp/FinanceReducer'));
export const DeliveryAndQualityReducer = createLazyRemoteReducer(() => import('remoteReactApp/DeliveryAndQualityReducer'));
export const ComplianceReducer = createLazyRemoteReducer(() => import('remoteReactApp/ComplianceReducer'));
export const FileDownloadReducer = createLazyRemoteReducer(() => import('remoteReactApp/FileDownloadReducer'));

export const ntier = createLazyRemoteReducer(() => import('remoteNTierApp/ntierSlice'));
export const ntierDashboard = createLazyRemoteReducer(() => import('remoteNTierApp/ntierDashboardSlice'));
